import { createValidation } from '../../../utils/validation';
export const createTrainingStatusValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateTrainingStatusData: validation.validateData, validateField: validation.validateField }; };
export default createTrainingStatusValidation;
